// extracted by mini-css-extract-plugin
export default {"clientIconsCol":"Header_clientIconsCol__K1qoi","shareButton":"Header_shareButton__8TCTu","row":"Header_row__waf-k","menu-icon":"Header_menu-icon__LMZ5H"};